import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CamerasWidget } from '@/widgets/cameras-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.searchByName': z.string().optional(),
  'filter.targetaiCameraIds': z.array(z.string()).optional(),
  'filter.cameraTypeIds': z.array(z.string()).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'filter.tenantIds': z.array(z.string()).optional(),
  'filter.targetaiSchoolIds': z.array(z.string()).optional(),
  'filter.active': z.boolean().optional(),
})

export const Route = createFileRoute('/_auth/administration/reference-books/cameras')({
  staticData: {
    meta: {
      title: 'Камеры Target AI',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.CAMERAS}>
      <PageWrapper title={t('Камеры Target AI')}>
        <CamerasWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
